// FOR: https://github.com/ant-design/antd-moment-webpack-plugin
import { isArr, isFn, isEmpty } from '@formily/shared';
import moment from 'moment';
export function dayjsable(value, format) {
    if (!value)
        return value;
    if (Array.isArray(value)) {
        return value.map(function (val) {
            var date = moment(val, format);
            if (date.isValid())
                return date;
            var _date = moment(val);
            return _date.isValid() ? _date : val;
        });
    }
    else {
        var date = moment(value, format);
        if (date.isValid())
            return date;
        var _date = moment(value);
        return _date.isValid() ? _date : value;
    }
}
export var formatDayjsValue = function (value, format, placeholder) {
    var validFormatDate = function (date, format) {
        if (typeof date === 'number') {
            return moment(date).format(format);
        }
        var _date = moment(date, format);
        return _date.isValid() ? _date.format(format) : date;
    };
    var formatDate = function (date, format, i) {
        if (i === void 0) { i = 0; }
        if (!date)
            return placeholder;
        if (isArr(format)) {
            var _format = format[i];
            if (isFn(_format)) {
                return _format(date);
            }
            if (isEmpty(_format)) {
                return date;
            }
            return validFormatDate(date, _format);
        }
        else {
            if (isFn(format)) {
                return format(date);
            }
            if (isEmpty(format)) {
                return date;
            }
            return validFormatDate(date, format);
        }
    };
    if (isArr(value)) {
        return value.map(function (val, index) {
            return formatDate(val, format, index);
        });
    }
    else {
        return value ? formatDate(value, format) : value || placeholder;
    }
};
//# sourceMappingURL=moment.js.map